



















import { Component, Prop } from 'vue-property-decorator';
import {User} from "@api/models/User";
import {IsMeetingsEnabled} from "@mixins/isMeetingsEnabled";
import NotificationsSwitcher from "@share/settings/notifications-switcher/NotificationsSwitcher.vue";
import LanguageSwitcher from "@share/settings/language-switcher/LanguageSwitcher.vue"

@Component({
    name: 'SettingsPart',
    components: { NotificationsSwitcher, LanguageSwitcher }
})
export default class SettingsPart extends IsMeetingsEnabled {
    @Prop({required: true}) isLoaded: boolean;
    @Prop({required: true}) user: User;

    get hideLanguages(): boolean {
        const params = this.$store.getters['events/selectedEventViewParam']('profile', null);
        return params?.hideLanguages && params.hideLanguages === true;
    }
}
